module.exports = __webpack_public_path__ + "img/7.449c9d7c.png";